var _defs, _rect, _polyline, _polygon, _polyline2, _polygon2, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThoiKhoaBieu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;}.cls-2{fill:#3d55a5;}.cls-3{fill:#fdbc42;}.cls-4{fill:#18b575;}.cls-5{fill:#ed1869;}.cls-6{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "31.22 193.29 31.22 168.84 194.54 168.93 194.54 193.32"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "218.93 56.68 218.93 81.08 55.52 81.12 55.52 193.29 31.12 193.29 31.07 56.68 218.93 56.68"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.48 56.68 218.93 56.68 218.93 168.93 194.54 168.93"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.54 168.93 194.54 193.32 218.93 168.93 194.54 168.93"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.54,119.34c6.9,2.4,11.55,8,11.55,15.2,0,5.66-1.94,10.15-5.74,13.33a21.25,21.25,0,0,1-14,4.81c-8.61,0-15.82-4-19-11.63l10.7-6.2c1.32,3.8,4.11,5.73,8.3,5.73,9.77.62,9.77-12.71,0-12.09h-2.56L104,121.43,113.88,109H94V97.32h34.89V107.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.82,97.32h10.86v54.27H145.27V110.42l-9.61,2.64-3-10.62Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 167.7,
    cy: 68.54,
    r: 5.49
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 82.3,
    cy: 68.54,
    r: 5.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoiKhoaBieu);
export default __webpack_public_path__ + "static/media/thoi_khoa_bieu.9b602551fd1998a6c62b64ce35fde212.svg";
export { ForwardRef as ReactComponent };